export const isActiveStyle = "text-2xl text-red-700 font-semibold hover:text-red-700 px-4 py-2 duration-100 transition-all ease-in-out";

export const isNotActiveStyles = "text-xl text-textColor hover:text-red-700 duration-100 px-4 py-2 transition-all ease-in-out";

export const statuses = [
    { id: 1, title: "Drinks", category: "drinks" },
    { id: 7, title: "Completed", category: "Completed" },
    { id: 8, title: "Foods", category: "Foods" },
];
